const changeForBRL = (realValue) =>{
  const valueFormated = realValue.toLocaleString("pt-BR", {
   style: "currency",
   currency: "BRL",
 })

 return valueFormated;
}

export {changeForBRL};